<template>
  <div>
    <Row class="expand-row" v-for="(good, index) in row" :key="index">
      <Col span="5" style="margin-left: 270px;">
        <!-- <span class="expand-key">物品名称: </span> -->
        <span class="expand-value">{{ good.goodsName }}</span>
      </Col>
      <Col span="5">
        <span class="expand-value">{{ good.price | initPrice }}</span>
      </Col>
      <Col span="1">
        <span class="expand-value">{{ good.purchasePrice | initPrice }}</span>
      </Col>
    </Row>
  </div>
</template>
<script>
// import {InitPrice} from '@/utils/tools';
export default {
  data () {
    return {}
  },
  props: {
      row: Array
  },
  filters: {
    initPrice(val) {
      return (val/100).toFixed(2)
    }
  }
};
</script>

<style scoped>
.expand-row{
    margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/table-consumables.vue